import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";
import type { ServiceModuleId } from "../../../service/service-modules";
import { SettingsLink } from "../service/service-fields";

const L = "engage.workflows.defaults.service";

/** Said of a default the module switch paused: which module, that nothing was deleted, and where to switch it on. */
export function ModuleOffNote({ module }: { module: ServiceModuleId }) {
  const { t } = useTranslation();
  const name = t(`${L}.module.names.${module}`);
  return (
    <p className="flex flex-wrap items-start gap-x-1.5 rounded-md bg-surface-2 p-2 text-xs text-fg-muted" data-testid="module-off-note">
      <Icon name="lock" className="mt-0.5 size-3.5 shrink-0" />
      <span className="min-w-0 flex-1">
        <span className="font-semibold text-fg">{t(`${L}.module.pausedTitle`, { module: name })}.</span> {t(`${L}.module.pausedBody`, { module: name })}{" "}
        <SettingsLink label={t(`${L}.module.openSettings`)} />
      </span>
    </p>
  );
}
